//TODO:!! wywalić owl i wywalić całkiem jq.

'use strict';

window.dataLayer = window.dataLayer || [];
var deviceTouch = 'ontouchstart' in document.documentElement;

$.extend($.easing, {
	easeOutExpo: function (x, t, b, c, d) {
		return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t == 0) return b;
		if (t == d) return b + c;
		if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
		return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
	},
});

if (localStorage.getItem('WPcrrf') === null) {
	localStorage.setItem('WPcrrf', '');
}

// zainicjowanie owli

// var owlText = $('.owl-text');
// var owlTimeline = $('.owl-timeline');
// var owlPhoto = $('.owl-photo');
var owl_1 = $('.owl_1');
var owl_wide = $('.owl_wide');
var owl_nav = $('.owl_nav');

owl_1.owlCarousel({
	loop: true,
	nav: true,
	center: true,
	margin: 10,
	items: 1,
	margin: 0,
	autoHeight: true,
});
owl_wide.owlCarousel({
	loop: true,
	nav: true,
	center: false,
	margin: 10,
	autoHeight: true,
	responsive: {
		0: { items: 1, margin: 1 },
		641: { items: 1.3, margin: 16 }
	},
});
owl_nav.owlCarousel({
	loop: false,
	nav: true,
	center: true,
	margin: 4,
	mouseDrag: false,   //  przeciąganie myszą
	touchDrag: false,   // palcem na mobile
	pullDrag: false,    // „ciągnięcie” slajdu
	responsive: {
		0: { items: 1, center: false },
		400: { items: 2, center: false },
		640: { items: 3, center: false },
		944: { items: 4, center: false },
		1366: { items: 5, center: false }
	},
});


// owlText.owlCarousel({
//   loop: true,
//   nav: true,
//   center: true,
//   margin: 10,
//   responsive: {
//     0: { items: 1, margin: 1 },
//     641: { items: 2, margin: 10 },
//     1141: { items: 4, margin: 10 },
//     1281: { items: 5, margin: 10 },
//   },
// });
// owlTimeline.owlCarousel({
//   loop: true,
//   nav: true,
//   dots: false,
//   center: true,
//   margin: 10,
//   responsive: {
//     0: { items: 1, margin: 1 },
//     641: { items: 2, margin: 10 },
//     1141: { items: 4, margin: 10 },
//     1281: { items: 5, margin: 10 },
//   },
// });

// owlPhoto.owlCarousel({
//   loop: true,
//   nav: true,
//   center: true,
//   responsive: {
//     0: { items: 1, margin: 1 },
//     881: { items: 3, margin: 10 },
//     1481: { items: 5, margin: 10 },
//   },
// });

//Obiekt zbierający informacje o elementach typu banner, slider, before/after, których statystyki należy wysłać w unload
var statElementCollector = new Object();
var ga360statElementsInit = function (el) {
	alert($(el).data('ga360-id'));
};

var slidePositionVieved = new Object();
//owlstats ga360 slider stats slider
var owl = $('.owl-carousel').each(function () {
	//sprawdzamy, czy jest ustawiony id dla statystyk
	var $artID = $(this).parents('.__js_stats_wrapper').data('id');
	var ga360id = $(this).data('ga360-id');
	if (ga360id == undefined) {
		console.log(
			'%c dodać ga360-id do slidera #' + $(this).data('id'),
			'background: #553311; padding: 3px; color: #ffaaaa'
		);
	} else {
		statElementCollector[ga360id + '-' + $artID] = {
			id: ga360id,
			moduleName: $(this).data('id'),
			viewedCount: 0,
			itemCount: $(this).find('.owl-item:not(.cloned)').length,
		};
	}
	$(this).statVievedSlide = [];
	//pozycje
	$(this)
		.find('.owl-item:not(.cloned)')
		.each(function (n) {
			$(this).attr('idx', n + 1);
		});
	slidePositionVieved[ga360id + '-' + $artID] = {};
});

function ga360Test() {
	var statElementArray = [];

	for (var pos in statElementCollector) {
		statElementArray.push(statElementCollector[pos]);
	}

	//console.log(statElementArray);
}

owl.find('.owl-next, .owl-prev').on('click', function (event) {
	var $owl = $(this).parents('.owl-carousel');
	var $artID = $(this).parents('.__js_stats_wrapper').data('id');
	var $gId = $(this).parents('.owl-carousel').data('id');
	var $acId = $owl.find('.owl-item.center').find('.owl_img>img').attr('src');
	//ga360
	var ga360id = $owl.data('ga360-id');
	var activeItem = $owl.find('.owl-item.center').attr('idx');
	slidePositionVieved[ga360id + '-' + $artID][activeItem] = 1;
	statElementCollector[ga360id + '-' + $artID]['viewedCount'] = Object.keys(
		slidePositionVieved[ga360id + '-' + $artID]
	).length;

	 sendStats('gallery', deviceTouch ? 'tap' : 'click', $artID + ' / ' + $gId, $acId);

	dataLayer.push({
		event: 'content_interaction',
		eventCategory: ga360id,
		moduleName: $gId,
		eventAction: deviceTouch ? 'tap' : 'click'
	});

});

owl.find('.owl-dot').on('click', function (event) {
	var $owl = $(this).parents('.owl-carousel');
	var $artID = $(this).parents('.__js_stats_wrapper').data('id');
	var $gId = $(this).parents('.owl-carousel').data('id');
	var $acId = $owl
		.find('.owl-item[idx="' + ($(this).index() + 1) + '"]')
		.find('.owl_img>img')
		.attr('src');
	//ga360

	var ga360id = $owl.data('ga360-id');
	var activeItem = $(this).index() + 1;
	slidePositionVieved[ga360id + '-' + $artID][activeItem] = 1;
	statElementCollector[ga360id + '-' + $artID]['viewedCount'] = Object.keys(
		slidePositionVieved[ga360id + '-' + $artID]
	).length;

	sendStats('gallery', 'click', $artID + ' / ' + $gId, $acId);

	window.dataLayer.push({
		event: 'content_interaction',
		eventCategory: ga360id,
		moduleName: $gId,
		eventAction: deviceTouch ? 'tap' : 'click'
	});

});

owl.on('dragged.owl.carousel', function (event) {
	var $artID = $(this).parents('.__js_stats_wrapper').data('id');
	var $gId = $(this).data('id');
	var $acId = $(this).find('.owl-item.center').find('.owl_img>img').attr('src');
	var ga360id = $(this).data('ga360-id');
	var activeItem = $(this).find('.owl-item.center').attr('idx');
	slidePositionVieved[ga360id + '-' + $artID][activeItem] = 1;
	statElementCollector[ga360id + '-' + $artID]['viewedCount'] = Object.keys(
		slidePositionVieved[ga360id + '-' + $artID]
	).length;
	sendStats('gallery', 'swipe', $artID + ' / ' + $gId, $acId);

	window.dataLayer.push({
		event: 'content_interaction',
		eventCategory: ga360id,
		moduleName: $gId,
		eventAction: 'swipe',
	});
});

var viewData = [];

// flaga dla scrollowania:
var isScrolligFlag = false;
var idTS;

window.addEventListener('scroll', function () {
	isScrolligFlag = true;
	if (idTS) {
		clearTimeout(idTS);
	}
	idTS = setTimeout(function () {
		idTS = null;
		isScrolligFlag = false;
	}, 450);
});

// $('[data-st-click]').bind('click', function () {
// 	var T = $(this).data('st-click');
// 	if (T) {
// 		if (T.value) {
// 			sendStats(T.category, T.action, T.label, T.value);
// 		} else {
// 			sendStats(T.category, T.action, T.label);
// 		}
// 	}
// });

function linkStats() {
	document.querySelectorAll("[data-ga360-click]").forEach((el) => {
		const clickEvent = function (ev) {
			el.addEventListener(ev, function () {
				const raw = this.getAttribute("data-ga360-click");
				let T = {};

				try {
					T = JSON.parse(raw);
				} catch (e) {
					console.warn("Błąd parsowania data-ga360-click:", e);
				}
				const eventAction =
					"ontouchstart" in document.documentElement ? "tap" : "click";

				window.dataLayer.push(
					{ event: 'site_interaction', eventCategory: T.eventCategory || '', eventAction: eventAction, eventLabel: T.eventLabel || '' }
				);
				sendStats(T.eventCategory, eventAction, T.eventLabel);
			});
		};
		clickEvent("click");
		clickEvent("auxclick");
		clickEvent("contextmenu");
	});
}
linkStats();